// GENERATED by scripts/gen-location-index.mjs — do not edit by hand.
// Lightweight slug/name/path/group data for site chrome (header, footer, strips)
// so the full location content module stays out of the public entry bundle.
export type LocationGroup = { id: string; label: string; slugs: string[] };
export type LocationLite = { name: string; path: string; slug: string; displayName: string };

export const LOCATION_GROUPS: LocationGroup[] = [
  {
    "id": "phoenix-central",
    "label": "Phoenix & Central Valley",
    "slugs": [
      "phoenix-roofing",
      "arcadia-roofing",
      "moon-valley-roofing",
      "desert-ridge-roofing",
      "ahwatukee-roofing",
      "melrose-district-roofing",
      "equestrian-manor-roofing",
      "north-phoenix-roofing",
      "tempe-roofing"
    ]
  },
  {
    "id": "east-valley",
    "label": "East Valley",
    "slugs": [
      "scottsdale-roofing-contractor",
      "paradise-valley-roofing",
      "mesa-roofing-contractor",
      "gilbert-roofing",
      "chandler-roofing",
      "queen-creek-roofing",
      "apache-junction-roofing",
      "mccormick-ranch-roofing",
      "tatum-ranch-roofing"
    ]
  },
  {
    "id": "north-scottsdale",
    "label": "North Scottsdale & Carefree",
    "slugs": [
      "cave-creek-roofing-contractor",
      "carefree-roofing-contractor",
      "fountain-hills-roofing-contractor",
      "troon-roofing",
      "desert-mountain-roofing",
      "desert-highlands-roofing",
      "silverleaf-roofing",
      "boulders-roofing",
      "sincuidados-roofing",
      "firerock-roofing",
      "clearwater-hills-roofing",
      "finisterre-roofing",
      "rio-verde-roofing"
    ]
  },
  {
    "id": "west-valley",
    "label": "West Valley",
    "slugs": [
      "glendale-roofing",
      "peoria-roofing-contractor",
      "surprise-roofing",
      "goodyear-roofing",
      "avondale-roofing",
      "buckeye-roofing",
      "tolleson-roofing"
    ]
  },
  {
    "id": "sun-city",
    "label": "Sun City Communities",
    "slugs": [
      "sun-city-roofing-contractor",
      "sun-city-west-roofing",
      "sun-city-grand-roofing",
      "vistancia-roofing",
      "coldwater-ranch-roofing",
      "anthem-roofing",
      "laguna-san-juan-roofing"
    ]
  },
  {
    "id": "outlying-arizona",
    "label": "Outlying Arizona",
    "slugs": [
      "wickenburg-roofing",
      "casa-grande-roofing",
      "sedona-roofing",
      "prescott-roofing",
      "prescott-valley-roofing",
      "tucson-roofing",
      "lake-havasu-city-roofing",
      "parker-roofing",
      "yuma-roofing"
    ]
  }
];

export const LOCATION_INDEX: Record<string, LocationLite> = {
  "scottsdale-roofing-contractor": {
    "name": "Scottsdale",
    "path": "/scottsdale-roofing-contractor",
    "slug": "scottsdale-roofing-contractor",
    "displayName": "Scottsdale, AZ"
  },
  "peoria-roofing-contractor": {
    "name": "Peoria",
    "path": "/peoria-roofing-contractor",
    "slug": "peoria-roofing-contractor",
    "displayName": "Peoria, AZ"
  },
  "sun-city-roofing-contractor": {
    "name": "Sun City",
    "path": "/sun-city-roofing-contractor",
    "slug": "sun-city-roofing-contractor",
    "displayName": "Sun City, AZ"
  },
  "fountain-hills-roofing-contractor": {
    "name": "Fountain Hills",
    "path": "/fountain-hills-roofing-contractor",
    "slug": "fountain-hills-roofing-contractor",
    "displayName": "Fountain Hills, AZ"
  },
  "carefree-roofing-contractor": {
    "name": "Carefree",
    "path": "/carefree-roofing-contractor",
    "slug": "carefree-roofing-contractor",
    "displayName": "Carefree, AZ"
  },
  "cave-creek-roofing-contractor": {
    "name": "Cave Creek",
    "path": "/cave-creek-roofing-contractor",
    "slug": "cave-creek-roofing-contractor",
    "displayName": "Cave Creek, AZ"
  },
  "mesa-roofing-contractor": {
    "name": "Mesa",
    "path": "/mesa-roofing-contractor",
    "slug": "mesa-roofing-contractor",
    "displayName": "Mesa, AZ"
  },
  "paradise-valley-roofing": {
    "name": "Paradise Valley",
    "path": "/paradise-valley-roofing",
    "slug": "paradise-valley-roofing",
    "displayName": "Paradise Valley, AZ"
  },
  "phoenix-roofing": {
    "name": "Phoenix",
    "path": "/phoenix-roofing",
    "slug": "phoenix-roofing",
    "displayName": "Phoenix, AZ"
  },
  "chandler-roofing": {
    "name": "Chandler",
    "path": "/chandler-roofing",
    "slug": "chandler-roofing",
    "displayName": "Chandler, AZ"
  },
  "tempe-roofing": {
    "name": "Tempe",
    "path": "/tempe-roofing",
    "slug": "tempe-roofing",
    "displayName": "Tempe, AZ"
  },
  "gilbert-roofing": {
    "name": "Gilbert",
    "path": "/gilbert-roofing",
    "slug": "gilbert-roofing",
    "displayName": "Gilbert, AZ"
  },
  "glendale-roofing": {
    "name": "Glendale",
    "path": "/glendale-roofing",
    "slug": "glendale-roofing",
    "displayName": "Glendale, AZ"
  },
  "surprise-roofing": {
    "name": "Surprise",
    "path": "/surprise-roofing",
    "slug": "surprise-roofing",
    "displayName": "Surprise, AZ"
  },
  "goodyear-roofing": {
    "name": "Goodyear",
    "path": "/goodyear-roofing",
    "slug": "goodyear-roofing",
    "displayName": "Goodyear, AZ"
  },
  "avondale-roofing": {
    "name": "Avondale",
    "path": "/avondale-roofing",
    "slug": "avondale-roofing",
    "displayName": "Avondale, AZ"
  },
  "buckeye-roofing": {
    "name": "Buckeye",
    "path": "/buckeye-roofing",
    "slug": "buckeye-roofing",
    "displayName": "Buckeye, AZ"
  },
  "tolleson-roofing": {
    "name": "Tolleson",
    "path": "/tolleson-roofing",
    "slug": "tolleson-roofing",
    "displayName": "Tolleson, AZ"
  },
  "queen-creek-roofing": {
    "name": "Queen Creek",
    "path": "/queen-creek-roofing",
    "slug": "queen-creek-roofing",
    "displayName": "Queen Creek, AZ"
  },
  "apache-junction-roofing": {
    "name": "Apache Junction",
    "path": "/apache-junction-roofing",
    "slug": "apache-junction-roofing",
    "displayName": "Apache Junction, AZ"
  },
  "troon-roofing": {
    "name": "Troon",
    "path": "/troon-roofing",
    "slug": "troon-roofing",
    "displayName": "Troon & Troon North, Scottsdale"
  },
  "desert-mountain-roofing": {
    "name": "Desert Mountain",
    "path": "/desert-mountain-roofing",
    "slug": "desert-mountain-roofing",
    "displayName": "Desert Mountain, Scottsdale"
  },
  "desert-highlands-roofing": {
    "name": "Desert Highlands",
    "path": "/desert-highlands-roofing",
    "slug": "desert-highlands-roofing",
    "displayName": "Desert Highlands, Scottsdale"
  },
  "silverleaf-roofing": {
    "name": "Silverleaf / DC Ranch",
    "path": "/silverleaf-roofing",
    "slug": "silverleaf-roofing",
    "displayName": "Silverleaf & DC Ranch, Scottsdale"
  },
  "boulders-roofing": {
    "name": "The Boulders",
    "path": "/boulders-roofing",
    "slug": "boulders-roofing",
    "displayName": "The Boulders, Carefree"
  },
  "sincuidados-roofing": {
    "name": "Sincuidados",
    "path": "/sincuidados-roofing",
    "slug": "sincuidados-roofing",
    "displayName": "Sincuidados, Scottsdale"
  },
  "firerock-roofing": {
    "name": "FireRock",
    "path": "/firerock-roofing",
    "slug": "firerock-roofing",
    "displayName": "FireRock, Fountain Hills"
  },
  "clearwater-hills-roofing": {
    "name": "Clearwater Hills",
    "path": "/clearwater-hills-roofing",
    "slug": "clearwater-hills-roofing",
    "displayName": "Clearwater Hills, Cave Creek"
  },
  "finisterre-roofing": {
    "name": "Finisterre",
    "path": "/finisterre-roofing",
    "slug": "finisterre-roofing",
    "displayName": "Finisterre, Scottsdale"
  },
  "mccormick-ranch-roofing": {
    "name": "McCormick Ranch",
    "path": "/mccormick-ranch-roofing",
    "slug": "mccormick-ranch-roofing",
    "displayName": "McCormick Ranch, Scottsdale"
  },
  "rio-verde-roofing": {
    "name": "Rio Verde",
    "path": "/rio-verde-roofing",
    "slug": "rio-verde-roofing",
    "displayName": "Rio Verde, AZ"
  },
  "arcadia-roofing": {
    "name": "Arcadia",
    "path": "/arcadia-roofing",
    "slug": "arcadia-roofing",
    "displayName": "Arcadia, Phoenix"
  },
  "moon-valley-roofing": {
    "name": "Moon Valley",
    "path": "/moon-valley-roofing",
    "slug": "moon-valley-roofing",
    "displayName": "Moon Valley, Phoenix"
  },
  "desert-ridge-roofing": {
    "name": "Desert Ridge",
    "path": "/desert-ridge-roofing",
    "slug": "desert-ridge-roofing",
    "displayName": "Desert Ridge, Phoenix"
  },
  "tatum-ranch-roofing": {
    "name": "Tatum Ranch",
    "path": "/tatum-ranch-roofing",
    "slug": "tatum-ranch-roofing",
    "displayName": "Tatum Ranch, Phoenix"
  },
  "ahwatukee-roofing": {
    "name": "Ahwatukee",
    "path": "/ahwatukee-roofing",
    "slug": "ahwatukee-roofing",
    "displayName": "Ahwatukee, Phoenix"
  },
  "north-phoenix-roofing": {
    "name": "North Phoenix",
    "path": "/north-phoenix-roofing",
    "slug": "north-phoenix-roofing",
    "displayName": "North Phoenix"
  },
  "melrose-district-roofing": {
    "name": "Melrose District",
    "path": "/melrose-district-roofing",
    "slug": "melrose-district-roofing",
    "displayName": "Melrose District, Phoenix"
  },
  "equestrian-manor-roofing": {
    "name": "Equestrian Manor",
    "path": "/equestrian-manor-roofing",
    "slug": "equestrian-manor-roofing",
    "displayName": "Equestrian Manor, Phoenix"
  },
  "sun-city-west-roofing": {
    "name": "Sun City West",
    "path": "/sun-city-west-roofing",
    "slug": "sun-city-west-roofing",
    "displayName": "Sun City West, AZ"
  },
  "sun-city-grand-roofing": {
    "name": "Sun City Grand",
    "path": "/sun-city-grand-roofing",
    "slug": "sun-city-grand-roofing",
    "displayName": "Sun City Grand, Surprise"
  },
  "vistancia-roofing": {
    "name": "Vistancia",
    "path": "/vistancia-roofing",
    "slug": "vistancia-roofing",
    "displayName": "Vistancia, Peoria"
  },
  "coldwater-ranch-roofing": {
    "name": "Coldwater Ranch",
    "path": "/coldwater-ranch-roofing",
    "slug": "coldwater-ranch-roofing",
    "displayName": "Coldwater Ranch, Peoria"
  },
  "anthem-roofing": {
    "name": "Anthem",
    "path": "/anthem-roofing",
    "slug": "anthem-roofing",
    "displayName": "Anthem, AZ"
  },
  "laguna-san-juan-roofing": {
    "name": "Laguna San Juan",
    "path": "/laguna-san-juan-roofing",
    "slug": "laguna-san-juan-roofing",
    "displayName": "Laguna San Juan, Peoria"
  },
  "wickenburg-roofing": {
    "name": "Wickenburg",
    "path": "/wickenburg-roofing",
    "slug": "wickenburg-roofing",
    "displayName": "Wickenburg, AZ"
  },
  "casa-grande-roofing": {
    "name": "Casa Grande",
    "path": "/casa-grande-roofing",
    "slug": "casa-grande-roofing",
    "displayName": "Casa Grande, AZ"
  },
  "sedona-roofing": {
    "name": "Sedona",
    "path": "/sedona-roofing",
    "slug": "sedona-roofing",
    "displayName": "Sedona, AZ"
  },
  "prescott-roofing": {
    "name": "Prescott",
    "path": "/prescott-roofing",
    "slug": "prescott-roofing",
    "displayName": "Prescott, AZ"
  },
  "prescott-valley-roofing": {
    "name": "Prescott Valley",
    "path": "/prescott-valley-roofing",
    "slug": "prescott-valley-roofing",
    "displayName": "Prescott Valley, AZ"
  },
  "tucson-roofing": {
    "name": "Tucson",
    "path": "/tucson-roofing",
    "slug": "tucson-roofing",
    "displayName": "Tucson, AZ"
  },
  "lake-havasu-city-roofing": {
    "name": "Lake Havasu City",
    "path": "/lake-havasu-city-roofing",
    "slug": "lake-havasu-city-roofing",
    "displayName": "Lake Havasu City, AZ"
  },
  "parker-roofing": {
    "name": "Parker",
    "path": "/parker-roofing",
    "slug": "parker-roofing",
    "displayName": "Parker, AZ"
  },
  "yuma-roofing": {
    "name": "Yuma",
    "path": "/yuma-roofing",
    "slug": "yuma-roofing",
    "displayName": "Yuma, AZ"
  }
};

export function locationNameOf(slug: string): string {
  return LOCATION_INDEX[slug]?.name ?? slug;
}
